import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { ScrapReasonModel, ScrapReasonWorkplaceModel } from '@/libs/Api';
import { ScrapReasonsDataService } from '@/libs/scrap-reasons/scrap-reasons-data-service';
import { ScrapReasonWorkplacesDataService } from '@/libs/scrap-reasons/scrap-reason-workplaces-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const scrapReasonsStore = registerCrudStore<ScrapReasonModel, ScrapReasonModel>(
    BusinessModule.ScrapReason,
    new ScrapReasonsDataService()
);

export const scrapReasonWorkplacesStore = registerCrudStore<ScrapReasonWorkplaceModel, ScrapReasonWorkplaceModel>(
    BusinessModule.ScrapReasonWorkplace,
    new ScrapReasonWorkplacesDataService()
);
